import React, { useRef } from "react";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { Button } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
const CodeSnippet = props => {
  const input = useRef();
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const copy = () => {
    input.current.focus();
    input.current.select();
    try {
      document.execCommand("copy");
      setMessage("Copied to clipboard");
    } catch (err) {
      console.error(err);
      setMessage("Failed to copy");
    } finally {
      setOpen(true);
    }
  };
  return (
    <div >
      <h5>{props.title.toUpperCase()}</h5>
      <pre style={{ padding: "1em" }}>
        <Button title="Copy to Clipboard" onClick={copy}>
          <FileCopyIcon color="action" style={{ color: "white" }} />
        </Button>
        <code>{props.text}</code>
      </pre>
      <input
        style={{ opacity: 0 }}
        ref={input}
        defaultValue={props.text}
      ></input>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
              Great!
            </Button>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};

export default CodeSnippet;
